import Filter from '@/components/modal-select/filters/Filter.js';

export default class TextFilter extends Filter {
    constructor(field, label) {
        super(field, label);

        this.type = 'text';

        this.handler = async ({ filterEvent }) => {
            const value = filterEvent.getAttribute('value');

            if (!value) {
                this.queryBuilder.removeFilter(this.field);
            } else {
                this.queryBuilder.filter(this.field, value);
            }
        };
    }
}
